module.exports = __webpack_public_path__ + "img/uncle.dc02e413.png";